import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  loadViolationsListSuccessful,
  loadViolationsListFailed, loadViolationsListBegin,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL_V2, DEFAULT_ITEMS_OF_PAGE, LOADING_DELAY } from '../../../configs';
import { addFilterQuery } from '../../../utils/addFilterQueryWithCondition';

export default function* loadViolationList(action) {
  try {
    const { payload = {} } = action;
    const {
      limit = DEFAULT_ITEMS_OF_PAGE,
      page = 1,
      filter,
      sort,
    } = payload;
    let pool = {
      limit,
      page,
      include: 'applicant,driver,vehicle,resolutionCreator',
    };
    if (typeof filter === 'object' && Object.keys(filter).length) {
      yield delay(LOADING_DELAY);
      pool.filter = addFilterQuery(filter);
    }
    if (typeof sort === 'string' && sort.length) {
      pool = { ...pool, sort };
    }
    yield put(loadViolationsListBegin());
    const url = `${BACKEND_URL_V2}/dict/violations/search`;

    const dataResponse = yield makeRequest(url, pool, action, 'POST', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadViolationsListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadViolationsListFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadViolationsListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
